import {FormEventHandler, useContext, useEffect, useState} from 'react'
import {Button, Form, FormGroup, Row} from 'react-bootstrap'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import Select from 'react-select'
import {Tooltip as ReactTooltip} from 'react-tooltip'
import {v4} from 'uuid'
import {get_Tables} from '../../../../services/campos'
import {getAllFindIdTabla, getAllFindTabla} from '../../../../services/tablas'
import {tipos} from '../../../../services/tipos'
import {screamingSnakeCaseTag, transformDependentType} from '../../../../shared/functions'
import {useUnidades} from '../../../../shared/hooks/useUnidades'
import {useAuth2} from '../../../authv2/Auth2Provider'
import {Field} from '../Sheet'
import {SheetEditContext} from '../SheetContexts'
import {DraggableTags} from './DraggableTags'

interface Type {
  _id: string
  nombre: string
  identificador: string
}

interface Table_Item {
  _id: string
  label: string
}

interface FieldExtended extends Field {
  isMultiple?: boolean
}

const FieldEditModalForm = () => {
  const {
    closeFieldModal,
    sheetData,
    setData,
    fieldData,
    setFieldData,
    sectionData,
    setSectionData,
    tables,
    setTables,
    types,
    setTypes,
  } = useContext(SheetEditContext)
  const [formData, setFormData] = useState<FieldExtended>({
    id: v4(),
    name: '',
    tag: '',
    isDependent: false,
    responseType: '',
    comment: '',
    valuesDefault: '',
    visible: true,
    editable: false,
    required: false,
    actualizable: false,
    collectionName: '',
    collectionId: '',
    options: [],
    tablaData: [],
    type: [],
    assignedTo: '',
    dependentField: '',
    dependentFieldResponse: '',
    isMultiple: false,
    variable: false,
  })

  // const [types, setTypes] = useState<Type[]>([])
  // const [tables, setTables] = useState<Table_Item[]>([])
  const [validated, setValidated] = useState(false)
  // const [selectedLabels, setSelectedLabels] = useState<string[]>([]);
  const [groupedOptions, setGroupedOptions] = useState<any>([])
  const [dataTabla, setDataTabla] = useState<any>([])
  const [dependentFieldResponses, setDependentFieldResponses] = useState<any>([])
  const [dependentFieldAux, setDependentFieldAux] = useState<Field>()
  const [sameNameError, setSameNameError] = useState<string | null>(null)
  const {misUnidades} = useUnidades()
  const {selectedRole, idEmpresaInterna} = useAuth2()

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter' && event.target.value) {
      event.preventDefault() // Prevent the default Enter key behavior (e.g., form submission)
      event.stopPropagation() // Stop the event propagation to prevent the modal from closing
    }
  }

  const handleTypeahead = (e: any) => {
    setFormData({
      ...formData,
      options: e,
    })
  }

  const CustomSelections = () => (
    // <Typeahead
    //   allowNew
    //   id='custom-selections'
    //   multiple
    //   newSelectionPrefix='Añade un nuevo elemento: '
    //   options={[]}
    //   defaultSelected={formData.options}
    //   placeholder='Escribe...'
    //   emptyLabel='Añade un nuevo elemento: '
    //   onKeyDown={handleKeyDown}
    //   onChange={handleTypeahead}
    // />
    <DraggableTags data={formData.options} onChange={handleTypeahead} />
  )

  const ListDB = () => (
    <FormGroup>
      <Form.Control
        as='select'
        name='collectionName'
        value={ tables.find(t => t.label === formData.collectionName || t._id === formData.collectionId)?._id }
        onChange={handleChange}
        placeholder='Seleccione el nombre de la tabla'
        size='sm'
        required
      >
        <option value=''>Seleccione una opción</option>
        {tables.map((table, index) => (
          <option key={index} value={table._id}>
            {table.label}
          </option>
        ))}
      </Form.Control>
      <Form.Control.Feedback type='invalid'>Seleccione una coleccion.</Form.Control.Feedback>
    </FormGroup>
  )

  const handleInputChange = (event: any) => {
    const {name, value, type} = event.target
    let fieldValue = value
    if (type === 'checkbox') {
      fieldValue = ''
      formData.options?.forEach((opc) => {
        opc.value = opc.label === name ? !opc.value : opc.value
        if (opc.value) fieldValue = fieldValue === '' ? opc.label : fieldValue + ',' + opc.label
      })
    } else if (type === 'select-one') {
      formData.options?.forEach((opc) => {
        opc.value = opc.label === value
      })
    } else if (type === 'radio') {
      formData.options?.forEach((opc) => {
        opc.value = opc.label === value ? true : false
      })
    }

    setFormData((prevFormData) => {
      return {...prevFormData, valuesDefault: fieldValue}
    })

    //setFormData({ ...formData, valuesDefault: fieldValue })
  }

  const handleInputChangeSelect = (selectOpion: any) => {
    let fieldValue = selectOpion
    setFormData((prevFormData) => {
      return {...prevFormData, optionDefault: fieldValue}
    })
  }

  const InputDefault = () => (
    <Form.Group className='mb-3' controlId='formComentario'>
      <Form.Label>Valor por defecto</Form.Label>
      <Form.Control
        type='text'
        placeholder='Ingrese un valor por defecto'
        name='valuesDefault'
        value={formData.valuesDefault}
        onChange={handleChange}
        className='same-height'
      />
    </Form.Group>
  )

  const InputNumberDefault = () => (
    <Form.Group className='mb-3' controlId='formComentario'>
      <Form.Label>Valor por defecto</Form.Label>
      <Form.Control
        type='number'
        placeholder='Ingrese un valor por defecto'
        name='valuesDefault'
        value={formData.valuesDefault}
        onChange={handleChange}
        className='same-height'
      />
    </Form.Group>
  )

  const InputDateDefault = () => (
    <Form.Group className='mb-3' controlId='formComentario'>
      <Form.Label>Valor por defecto</Form.Label>
      <Form.Control
        type='date'
        placeholder='Ingrese un valor por defecto'
        name='valuesDefault'
        value={formData.valuesDefault}
        onChange={handleChange}
        className='same-height'
      />
    </Form.Group>
  )

  const ListaDesplegableDefault = () => (
    <Form.Group className='mb-3' controlId='formComentario'>
      <Form.Label>Valor por defecto</Form.Label>
      <select
        className={`form-select form-control-solid`}
        aria-label='Select example'
        name={formData.responseType}
        value={formData.valuesDefault}
        onChange={(event) => handleInputChange(event)}
      >
        <option value=''>Seleccionar</option>
        {formData.options?.map((opc) => (
          <option value={opc.label}> {String(opc.label)}</option>
        ))}
      </select>
    </Form.Group>
  )

  const ListaDesplegableBDDefault = () => (
    <Form.Group className='mb-3' controlId='formComentario'>
      <Form.Label>Valor por defecto</Form.Label>
      <div>
        <Select
          name={formData.id}
          placeholder='Seleccione un campo'
          styles={{
            control: (provided, state) => ({
              ...provided,
              minHeight: '34px',
              height: '34px',
              fontFamily: 'inherit',
              fontSize: '0.95rem',
              color: '#5e6278',
            }),
          }}
          options={
            dataTabla.length > 0 ? dataTabla.map((t: any) => ({label: t.name, value: t.id})) : []
          }
          value={formData.optionDefault ? formData.optionDefault : null}
          onChange={(selectedOption) => {
            handleInputChangeSelect(selectedOption)
          }}
        />
      </div>
    </Form.Group>
  )

  const ListaCheckboxDefault = () => (
    <Form.Group className='mb-3' controlId='formComentario'>
      <Form.Label>Valor por defecto</Form.Label>
      <div className='mb-2 d-flex flex-wrap'>
        {formData.options?.map((opc, idx2) => (
          <div className={`form-check form-check-custom form-check-sm m-2`}>
            <input
              className={`form-check-input`}
              type='checkbox'
              name={opc.label}
              checked={formData.options?.[idx2].value ? true : false}
              onChange={(event) => handleInputChange(event)}
            />
            <label className='form-check-label' htmlFor={'flexRadioLg' + idx2}>
              {opc.label}
            </label>
          </div>
        ))}
      </div>
    </Form.Group>
  )

  useEffect(() => {
    if (groupedOptions) {
      const concatenatedOptions = groupedOptions.reduce(
        (accumulator: any, current: any) => {
          return {options: accumulator.options.concat(current.options)}
        },
        {options: []}
      ).options

      const filteredResponses = concatenatedOptions.filter(
        (option: any) => option.value === formData.dependentField
      )

      const dependentFieldResponses = filteredResponses.map((x: any) => x.responses)
      const isArray = Array.isArray(transformDependentType(formData.dependentFieldResponse ?? ''))
      setFormData({...formData, isMultiple: isArray})
      setDependentFieldResponses(dependentFieldResponses)
    }
  }, [formData.dependentField, groupedOptions])

  useEffect(() => {
    ActualizarTabla()
  }, [formData])

  useEffect(() => {
    getTypes()
    getDependentData()
    if (fieldData.id.length > 0) {
      if (fieldData.tablaData.length > 0) {
        getTableFindId(fieldData.tablaData[0]._id)
      }
      // getTableFind
      setFormData(fieldData)
    } else {
      setFormData({
        id: v4(),
        name: '',
        tag: '',
        isDependent: false,
        responseType: '',
        comment: '',
        valuesDefault: '',
        optionDefault: null,
        visible: true,
        editable: false,
        required: false,
        actualizable: false,
        collectionName: '',
        collectionId: '',
        options: [],
        tablaData: [],
        type: [],
        assignedTo: '',
        dependentField: '',
        dependentFieldResponse: '',
        variable: false,
      })
    }
  }, [])

  const getTypes = async () => {
    try {
      const response = await tipos()
      if (response.success) {
        setTypes(response.data)
        return response.data
      } else {
        return []
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getTables = () => {
    get_Tables()
      .then((response) => {
        setTables(response.data)
      })
      .catch((error) => console.log(error))
  }

  const getTableFind = (name: string) => {
    getAllFindTabla(name)
      .then((response) => {
        if (formData.dependentField) {
          setDataTabla(
            response.data.filter(
              (dat: any) => String(dat.parent_id) == String(dependentFieldAux?.optionDefault.value)
            )
          )
        } else {
          setDataTabla(response.data)
        }
      })
      .catch((error) => console.log(error))
  }

  const getTableFindId = (id: string) => {
    getAllFindIdTabla(id)
      .then((response) => {
        if (formData.dependentField) {
          setDataTabla(
            response.data.filter(
              (dat: any) => String(dat.parent_id) == String(dependentFieldAux?.optionDefault.value)
            )
          )
        } else {
          setDataTabla(response.data)
        }
      })
      .catch((error) => console.log(error))
  }

  const handleChange = (e: any) => {
    if (e.target.name === 'name') {
      // agregar niveles en etiquetas
      setSameNameError(null)
      const tag = '{' + screamingSnakeCaseTag(e.target.value) + '}'
      formData.tag = tag
    }

    if (e.target.name === 'collectionName') {
      const label = e.target.options[e.target.selectedIndex].text;
      getTableFindId(e.target.value)
      setFormData({...formData, [e.target.name]: label, collectionId: e.target.value})
    }else{
      setFormData({...formData, [e.target.name]: e.target.value})
    }

  }

  const handleChangeType = async (e: any) => {
    const value = e.target.value

    // call an api
    const typeMapping: Record<string, {identificador: string; nombre: string}> = (
      types ?? []
    ).reduce((acc: any, type) => {
      acc[type._id] = {identificador: type.identificador, nombre: type.nombre}
      return acc
    }, {})

    // Buscamos si `value` está en el mapeo
    const selectedType = typeMapping[value]

    setFormData((prevFormData) => ({
      ...prevFormData,
      [e.target.name]: value,
      type: selectedType ? [{...selectedType, _id: value}] : [], // Si no hay coincidencia, se asigna un array vacío
    }))
  }
  const ActualizarTabla = () => {
    if (formData.dependentField) {
      sheetData.sections?.map((section) => {
        section.fields?.map((field) => {
          if (field.id == formData.dependentField) {
            setDependentFieldAux(field)
          }
        })
      })
    }
  }

  const validateForm: FormEventHandler<HTMLFormElement> = (e) => {
    const form = e.currentTarget

    const sectionFields = sectionData.fields
    const hasSameName = sectionFields?.some(
      (x) => x.name?.toLowerCase() === formData.name?.toLowerCase() && formData.id !== x.id
    )

    if (!form.checkValidity()) {
      e.preventDefault()
      e.stopPropagation()
    }

    if (hasSameName) {
      setSameNameError('El nombre se esta repitiendo en esta sección')
      e.preventDefault()
      e.stopPropagation()
      setValidated(false)
      return
    }

    if (form.checkValidity() && !hasSameName) {
      setSameNameError(null)
      handleSubmit(e)
    }

    setValidated(true)
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()
    if (fieldData.id.length > 0) {
      setData({
        ...sheetData,
        sections: (sheetData.sections || []).map((x) =>
          x.id === sectionData.id
            ? {
                ...sectionData,
                fields: (sectionData.fields || []).map((y) => {
                  if (y.id === fieldData.id) {
                  }
                  return y.id === fieldData.id ? formData : y
                }),
              }
            : x
        ),
      })
    } else {
      setData({
        ...sheetData,
        sections: (sheetData.sections || []).map((x) =>
          x.id === sectionData.id
            ? {...sectionData, fields: [...(sectionData.fields || []), formData]}
            : x
        ),
      })
    }

    closeFieldModal()
  }

  const handleDependent = (event: any) => {
    if (event.target.checked) {
      setFormData({
        ...formData,
        isDependent: event.target.checked,
        required: false,
        dependentField: '',
        dependentFieldResponse: '',
      })
    } else {
      setFormData({...formData, isDependent: event.target.checked})
    }

    getDependentData()
  }

  const handleChangeMultiple = (e: any) => {
    setFormData({...formData, isMultiple: e.target.checked})
  }

  const getDependentData = () => {
    const output = sheetData.sections
      ?.map((section) => {
        if (!section.fields || section.fields.length === 0) return null

        const fieldsWithOptions = section.fields.map((field) => {
          const {id, name, options} = field
          const optionsArray = options?.map((option) => ({
            value: option.value,
            label: option.label,
            id: option.id,
          }))
          return {id, label: name, options: optionsArray}
        })

        return {id: section.id, label: section.name, options: fieldsWithOptions.filter(Boolean)}
      })
      .filter(Boolean)

    const dependentFields = output?.map((x) => ({
      label: x?.label,
      options: x?.options?.map((y) => ({
        value: y?.id,
        label: y?.label,
        responses: y.options?.map((response) => ({
          value: response.id,
          label: response.label,
        })),
      })),
    }))
    setGroupedOptions(dependentFields)
  }

  const handleDependentSelect = (e: any) => {
    if (groupedOptions) {
      const concatenatedOptions = groupedOptions.reduce((accumulator: any, current: any) => {
        return accumulator.concat(current.options)
      }, [])

      const filteredResponses = concatenatedOptions.filter(
        (option: any) => option.value === e.target.value
      )

      const dependentFieldResponses = filteredResponses.map((x: any) => x.responses)
      setDependentFieldResponses(dependentFieldResponses)
    }

    handleChange(e)
  }

  const handleRequiredCheckboxChange = (e: any) => {
    if (e.target.checked) {
      setFormData({
        ...formData,
        required: e.target.checked,
        visible: e.target.checked,
        // isDependent: false,
        // dependentField: '',
        // dependentFieldResponse: '',
      })
    } else {
      setFormData({...formData, required: e.target.checked})
    }
  }

  const handleActualizableCheckboxChange = (e: any) => {
    setFormData({...formData, actualizable: e.target.checked})
    /* if (e.target.checked) {
      setFormData({ ...formData, required: e.target.checked, visible: e.target.checked, isDependent: false, dependentField: '', dependentFieldResponse: '' })
    } else {
      setFormData({ ...formData, required: e.target.checked })
    } */
  }

  const handleVisibleCheckboxChange = (e: any) => {
    if (formData.required) {
      setFormData({...formData, visible: e.target.checked, required: e.target.checked})
    } else {
      setFormData({...formData, visible: e.target.checked})
    }
  }

  const handleChangeMulti = (e: any) => {
    const values = e.map((e: any) => e.label)
    setFormData({...formData, dependentFieldResponse: values.join('@')})
  }

  return (
    <>
      <Form validated={validated} onSubmit={validateForm} noValidate>
        <Form.Group className='mb-3' controlId='formNombre'>
          <Form.Label>Nombre</Form.Label>
          <Form.Control
            type='text'
            required
            placeholder='Ingrese un nombre'
            name='name'
            value={formData.name}
            onChange={handleChange}
            className='same-height'
            isInvalid={!!sameNameError}
          />
          <Form.Control.Feedback type='invalid'>
            {sameNameError ? sameNameError : 'Escriba un nombre para el campo.'}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Check // prettier-ignore
          type='checkbox'
          id='dependentCheckbox'
          label='Dependiente'
          className='mb-3'
          checked={formData.isDependent}
          onChange={(event) => handleDependent(event)}
        />

        {formData.isDependent ? (
          <>
            <Form.Group className='mb-3' controlId='formCampoDependiente'>
              <Form.Label>Campo Dependiente</Form.Label>
              <Form.Control
                as='select'
                name='dependentField'
                value={formData.dependentField}
                onChange={handleDependentSelect}
                required
              >
                <option value=''>Seleccione un campo</option>
                {groupedOptions.map((section: any, index: number) => (
                  <optgroup key={index} label={section.label}>
                    {section.options.map((option: any) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </optgroup>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group className='mb-3' controlId='formRespuestaCampoDependiente'>
              <Form.Check
                type='checkbox'
                id='multipleCheckbox'
                label='Múltiple'
                className='mb-3'
                checked={formData.isMultiple ?? false}
                onChange={(event) => handleChangeMultiple(event)}
              />

              <Form.Label>Respuesta de Campo Dependiente</Form.Label>
              {formData.isMultiple === true ? (
                <Select
                  options={dependentFieldResponses[0]?.map((x: any) => ({
                    label: x.label,
                    value: x.label,
                  }))}
                  isMulti
                  onChange={handleChangeMulti}
                  defaultValue={
                    formData.dependentFieldResponse
                      ? formData.dependentFieldResponse
                          .split('@')
                          .map((x: any) => ({label: x, value: x}))
                      : null
                  }
                />
              ) : (
                <Form.Control
                  as='select'
                  name='dependentFieldResponse'
                  value={formData.dependentFieldResponse}
                  onChange={handleChange}
                >
                  <option value=''>Seleccione un campo</option>
                  {dependentFieldResponses
                    ? dependentFieldResponses[0]?.map((response: any) => (
                        <option key={response.value} value={response.label}>
                          {response.label}
                        </option>
                      ))
                    : null}
                </Form.Control>
              )}
            </Form.Group>
          </>
        ) : null}

        <Form.Group className='mb-3' controlId='formTipoRespuesta'>
          <Form.Label>Tipo de Respuesta</Form.Label>
          <Form.Control
            as='select'
            name='responseType'
            value={formData.responseType}
            onChange={handleChangeType}
            className={'form-select form-select-solid}'}
            required
          >
            <option value=''>Seleccione una opción</option>
            {types.map((type, index) => (
              <option key={index} value={type._id}>
                {type.nombre
                  .split(' ')
                  .map((word, index) => {
                    const excepciones = ['de', 'y', 'o', 'a', 'en', 'con', 'para', 'por']
                    return excepciones.includes(word.toLowerCase()) && index !== 0
                      ? word.toLowerCase()
                      : word.charAt(0).toUpperCase() + word.slice(1)
                  })
                  .join(' ')}
              </option>
            ))}
          </Form.Control>
          <Form.Control.Feedback type='invalid'>
            Seleccione un tipo de respuesta para el campo.
          </Form.Control.Feedback>
        </Form.Group>

        <div className='mb-3'>
          {types.find((type) => type.identificador === 'dropdownlist')?._id ===
          formData.responseType
            ? CustomSelections()
            : null}
          {types.find((type) => type.identificador === 'dropdownlist_db')?._id ===
          formData.responseType
            ? ListDB()
            : null}
          {types.find((type) => type.identificador === 'checkbox')?._id === formData.responseType
            ? CustomSelections()
            : null}
        </div>

        <div className='mb-3'>
          {types.find((type) => type.identificador === 'textbox')?._id === formData.responseType
            ? InputDefault()
            : types.find((type) => type.identificador === 'number')?._id === formData.responseType
            ? InputNumberDefault()
            : types.find((type) => type.identificador === 'date')?._id === formData.responseType
            ? InputDateDefault()
            : types.find((type) => type.identificador === 'dropdownlist')?._id ===
              formData.responseType
            ? ListaDesplegableDefault()
            : types.find((type) => type.identificador === 'dropdownlist_db')?._id ===
              formData.responseType
            ? ListaDesplegableBDDefault()
            : types.find((type) => type.identificador === 'checkbox')?._id === formData.responseType
            ? ListaCheckboxDefault()
            : null}
        </div>

        <Form.Group className='mb-3' controlId='formComentario'>
          <Form.Label>
            Comentario
            <i
              className={'fas fa-exclamation-circle ms-2 fs-5 text-primary'}
              data-tooltip-id={'my-tooltip-1'}
            ></i>
            <ReactTooltip
              id={'my-tooltip-1'}
              place='bottom'
              variant={'info'}
              content={'Breve descripción del campo'}
            />
          </Form.Label>
          <Form.Control
            type='text'
            placeholder='Ingrese un comentario'
            name='comment'
            value={formData.comment}
            onChange={handleChange}
            className='same-height'
          />
        </Form.Group>

        <div className='form-check mb-3'>
          <input
            type='checkbox'
            id='visibleCheckbox'
            // label='Visible'
            className='form-check-input'
            checked={formData.visible}
            onChange={(event) => handleVisibleCheckboxChange(event)}
          />
          <label htmlFor='visibleCheckbox'>Visible</label>
        </div>

        <div className='form-check mb-3'>
          <input
            type='checkbox'
            id='editableCheckbox'
            // label='Editable'
            className='form-check-input'
            checked={formData.editable}
            onChange={(event) => setFormData({...formData, editable: event.target.checked})}
          />
          <label htmlFor='editableCheckbox'>Editable</label>
        </div>

        <div className='form-check mb-3'>
          <input
            type='checkbox'
            id='requiredCheckbox'
            // label='Obligatorio'
            className='form-check-input'
            checked={formData.required}
            onChange={(event) => handleRequiredCheckboxChange(event)}
          />
          <label htmlFor='requiredCheckbox'>Obligatorio</label>
        </div>

        <div className='form-check mb-3'>
          <input
            type='checkbox'
            id='variableCheckbox'
            // label='Replicable'
            className='form-check-input'
            checked={formData.variable}
            onChange={(e) => {
              setFormData({...formData, variable: e.target.checked})
            }}
          />
          <label htmlFor='variableCheckbox'>Replicable</label>
        </div>
        {/* <Form.Check
          type='checkbox'
          id='actualizableCheckbox'
          label='Actualizable'
          className='mb-3'
          checked={formData.actualizable}
          onChange={(event) => handleActualizableCheckboxChange(event)}
        /> */}

        <Row>
          <div className='d-flex justify-content-end'>
            <Button
              variant='light'
              className='mx-3'
              type='reset'
              onClick={() => {
                closeFieldModal()
              }}
            >
              Cancelar
            </Button>
            <Button variant='primary' type='submit'>
              Guardar
            </Button>
          </div>
        </Row>
      </Form>
    </>
  )
}

export {FieldEditModalForm}
